import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SearchForm from "../../components/SearchForm";
import { URL, getToken } from "../../utils";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import ConditionalRender from "../../components/ConditionalRender";

export default function Commercials() {
  const [commercials, setCommercials] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCommercials, setFilteredCommercials] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = getToken();

  useEffect(() => {
    fetchCommercials();
  }, []);

  const fetchCommercials = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${URL}Magasins/commercial/liste-commerciaux`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCommercials(response.data);
    } catch (error) {
      toast.error("Erreur lors du chargement des commerciaux:");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    if (term) {
      const filtered = commercials.filter((commercial) =>
        `${commercial.prenom} ${commercial.nom}`
          .toLowerCase()
          .includes(term.toLowerCase())
      );
      setFilteredCommercials(filtered);
    } else {
      setFilteredCommercials([]);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="shadow-md bg-white p-4 flex justify-between items-center sticky top-16 z-10">
        <SearchForm
          onSearch={handleSearch}
          placeholder="Rechercher un commercial"
        />

        <ConditionalRender requiredPermissions={"canCreateCommercial"}>
          <Link
            to="/commercials/add"
            className="p-2 px-4 rounded-md bg-amber-500 text-white hover:bg-amber-600 focus:ring-2 border-2 border-amber-400 focus:ring-offset-2 focus:ring-amber-400 text-sm max-sm:hidden"
          >
            Ajouter un commercial
          </Link>

          <Link
            to="/commercials/add"
            className="text-gray-600 max-sm:ml-10 hover:text-amber-500 focus:ring-2 focus:ring-amber-400 focus:ring-offset-2 focus:ring-offset-amber-100 focus:outline-none rounded-md p-1 sm:hidden"
          >
            <svg
              className="w-8 h-8"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fillRule="evenodd"
                d="M4.857 3A1.857 1.857 0 0 0 3 4.857v4.286C3 10.169 3.831 11 4.857 11h4.286A1.857 1.857 0 0 0 11 9.143V4.857A1.857 1.857 0 0 0 9.143 3H4.857Zm10 0A1.857 1.857 0 0 0 13 4.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 21 9.143V4.857A1.857 1.857 0 0 0 19.143 3h-4.286Zm-10 10A1.857 1.857 0 0 0 3 14.857v4.286C3 20.169 3.831 21 4.857 21h4.286A1.857 1.857 0 0 0 11 19.143v-4.286A1.857 1.857 0 0 0 9.143 13H4.857ZM18 14a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Z"
                clipRule="evenodd"
              />
            </svg>
          </Link>
        </ConditionalRender>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-amber-500"></div>
        </div>
      ) : (
        <div className="p-4">
          <div className="text-2xl font-semibold flex justify-between items-center p-2">
            <h2>
              Commerciaux (
              {searchTerm !== ""
                ? filteredCommercials.length
                : commercials.length}
              )
            </h2>
            <div className="flex items-center gap-4">
              <Link
                to="#"
                className="flex items-center justify-center p-2 bg-white shadow-md rounded-md"
              >
                <svg
                  className="w-6 h-6"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m15 19-7-7 7-7"
                  />
                </svg>
              </Link>
              <Link
                to="#"
                className="flex items-center justify-center p-2 bg-white shadow-md rounded-md"
              >
                <svg
                  className="w-6 h-6"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m9 5 7 7-7 7"
                  />
                </svg>
              </Link>
            </div>
          </div>
          <div className="bg-gray-50 grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-4 p-4 overflow-auto">
            {searchTerm !== "" ? (
              filteredCommercials.length > 0 ? (
                filteredCommercials.map((commercial) => (
                  <CardSimpleCommercial
                    key={commercial.id}
                    commercial={commercial}
                    to="/commercials/details"
                  />
                ))
              ) : (
                <div className="text-center text-gray-500 mt-4">
                  Aucun commercial trouvé.
                </div>
              )
            ) : commercials.length > 0 ? (
              commercials.map((commercial) => (
                <CardSimpleCommercial
                  key={commercial.id}
                  commercial={commercial}
                  to="/commercials/details"
                />
              ))
            ) : (
              <div className="text-center text-gray-500 mt-4">
                Aucun commercial trouvé.
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
function CardSimpleCommercial({ commercial, to }) {
  return (
    <Link
      to={`${to}/${commercial.id}`}
      className="block border border-gray-200 p-3 bg-white rounded-lg hover:shadow-md transition-shadow"
    >
      {/* En-tête compacte */}
      <div className="flex justify-between items-start gap-2">
        <div className="min-w-0">
          <h3 className="font-semibold text-base truncate">
            {commercial.prenom} {commercial.nom}
          </h3>
          <p className="text-xs text-gray-500 truncate">
            Magasin {commercial.magasin_name}
          </p>
        </div>

        <div className="flex items-center gap-1 flex-shrink-0">
          <span
            className={`text-xs px-1.5 py-0.5 rounded-full ${
              commercial.is_active
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-800"
            }`}
          >
            {commercial.is_active ? "Actif" : "Inactif"}
          </span>
          <span className="text-xs px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-800">
            #{commercial.id}
          </span>
        </div>
      </div>

      {/* Informations principales en ligne compacte */}
      <div className="mt-2 flex items-center justify-between text-sm">
        <div className="flex items-center gap-1 text-amber-600">
          <svg
            className="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
            />
          </svg>
          <span>{commercial.telephone}</span>
        </div>

        <span
          className={`text-xs px-1.5 py-0.5 rounded-full ${
            commercial.sexe === "M"
              ? "bg-blue-100 text-blue-800"
              : "bg-pink-100 text-pink-800"
          }`}
        >
          {commercial.sexe === "M" ? "♂" : "♀"}
        </span>
      </div>

      {/* Section objectifs compacte */}
      <div className="mt-2 grid grid-cols-2 gap-2">
        <div className="bg-blue-50 p-2 rounded border border-blue-100">
          <div className="flex items-center justify-between">
            <span className="text-xs text-blue-800">Quotidien</span>
            <svg
              className="w-3 h-3 text-blue-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <p className="text-sm font-medium text-blue-600">
            {commercial.objectif_journalier.toLocaleString()} F
          </p>
        </div>

        <div className="bg-purple-50 p-2 rounded border border-purple-100">
          <div className="flex items-center justify-between">
            <span className="text-xs text-purple-800">Mensuel</span>
            <svg
              className="w-3 h-3 text-purple-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
          <p className="text-sm font-medium text-purple-600">
            {commercial.objectif_mensuel.toLocaleString()} F
          </p>
        </div>
      </div>

      {/* Informations secondaires avec tooltip */}
      <div className="mt-2 flex items-center justify-between text-xs">
        <div className="flex items-center gap-1">
          <span className="px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-800">
            {commercial.nbre_prospects} prospects
          </span>
          <span className="px-1.5 py-0.5 rounded-full bg-green-100 text-green-800">
            {commercial.chiffre_affaire.toLocaleString()} F
          </span>
        </div>

        <div className="relative group">
          <svg
            className="w-4 h-4 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <div className="absolute hidden group-hover:block right-0 bottom-full mb-1 w-48 p-2 bg-white shadow-lg rounded border text-xs z-10">
            <p>
              <strong>Adresse:</strong> {commercial.adresse || "-"}
            </p>
            <p>
              <strong>Naissance:</strong> {commercial.date_naissance || "-"}
            </p>
            <p>
              <strong>Situation:</strong> {commercial.situation_mat || "-"}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
}
